import { CoordinateSource } from '@core/models/location.model';

export function hasPlaceableAddress(
  postalCode: string | null | undefined,
  streetNumber: number | string | null | undefined,
): boolean {
  return !!postalCode?.trim() && streetNumber != null && String(streetNumber).trim() !== '';
}

// A pin is a fallback for an address that cannot be found, never a substitute for a missing one or
// an override of a found one. The backend geocodes on every address save and a found address always
// replaces a manual pin, so a manual pin means the address could not be found. A geocoded pair, or
// one with no source (stored before the source was tracked, and geocoded then), needs no pin.
export function shouldOfferPlaceOnMap(location: {
  postalCode: string | null | undefined;
  streetNumber: number | string | null | undefined;
  latitude: string | null | undefined;
  longitude: string | null | undefined;
  coordinateSource: CoordinateSource | null | undefined;
}): boolean {
  if (!hasPlaceableAddress(location.postalCode, location.streetNumber)) {
    return false;
  }
  const hasCoordinates = !!location.latitude && !!location.longitude;
  return !hasCoordinates || location.coordinateSource === 'manual';
}
